var _circle, _rect, _path, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragAndDropImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#FDBA74"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.575,
    y: 26.7,
    width: 44.6,
    height: 35.6,
    rx: 3.3,
    fill: "white",
    stroke: "#EA580C",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.875 57.5L36.0918 39.0123C36.7885 37.4445 39.0063 37.4241 39.7318 38.9788L48.375 57.5",
    stroke: "#EA580C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.375 51.5L49.4797 43.2906C50.2356 41.7788 52.4097 41.8281 53.0962 43.3727L59.375 57.5",
    stroke: "#EA580C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.875,
    cy: 35,
    r: 4.5,
    fill: "#FDBA74",
    stroke: "#EA580C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDropImage);
export default __webpack_public_path__ + "static/media/dragAndDropImage.bebec3c268ca1279713eac30e32762e2.svg";
export { ForwardRef as ReactComponent };